export default __webpack_public_path__ + "8679229476fd1885a8fc8e68f6a8dd5f.png";